module.exports = __webpack_public_path__ + "static/media/zone.89bf1c87.svg";